import { render, staticRenderFns } from "./UploadErrors.vue?vue&type=template&id=ddd5b8a2&lang=pug&"
import script from "./UploadErrors.vue?vue&type=script&lang=js&"
export * from "./UploadErrors.vue?vue&type=script&lang=js&"
import style0 from "./UploadErrors.vue?vue&type=style&index=0&id=ddd5b8a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports